// NOTE: Dependencies: jQuery

(function($) {
	$.fn.ppProgressBar = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body')
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		};

		methods.initContext = function() {
			methods.setCurrentSettings();
		};


		methods.init = function() {
			var dataCurrent = $context.attr('data-current'),
				dataTotal = $context.attr('data-total'),
				dataPercentage = (100 / dataTotal) * dataCurrent;

			setTimeout(function() {
				$context.find('.partner-portal-welcome-panel__progress-current').css('width', dataPercentage + '%');
			}, 1000);
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
			
		// NOTE: Method you'd like initialized on a per context basis.
		methods.initContext($(this));

		// Run once methods when jquery plugin is called.
		methods.init(this);
	};

	if ($('.partner-portal-welcome-panel__progress-bar').length) {
		$('.partner-portal-welcome-panel__progress-bar').ppProgressBar();
	}

}(jQuery));
